<template>
    <b-container>
        <h1>{{ $t("tracking.occurrenceType.edit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" /> 
      <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />

      <b-form @submit.prevent="save">
      <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>

        
      <b-row>
        <b-col sm="12" md="6" lg="6">
          <occurrence-type-crud-data
            :model="model"
            :modelstate="modelstate"
            :readonly="false"
            class="mb-4"
          >
          </occurrence-type-crud-data>
        </b-col>
        
      </b-row>
      
      <b-row>       
        <b-col>
          <b-button type="submit" :disabled="submitted">
            {{ $t("geral.save") }}
          </b-button>
        </b-col>
      </b-row>
     </b-form>
    <div>
      <!-- {{model}} -->
    </div>
   
</b-container>

</template>

<script>

export default {
  name: "OccurrenceTypeEdit",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    OccurrenceTypeCrudData: () =>
      import(
        "@/components_rms/trackingShippingCompany/occurrenceType/occurrenceTypeCrudData.vue"
      ),
  },
  props: {
    id: String
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Ocorrência criada com sucesso",
      },
      submitted: false,
      modelstate: {},
      model: {
        sequenceNumber: "",
        description : "",
        id: 0,
        companyId:0,
        profiles: "",
        occurrenceTypeNext: "",
        customFields: [],
      },
    };
    
  },
  mounted() {
    this.loadData();
  },
  computed: {
    canEdit() {
      if (!this.model) {
        return false;
      }
      return true;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBackToList() {

      return `../../occurrenceType/list`;
    },
    getUrlOccurrenceTypeList() {
      if (this.companyId) {
        return `/v1/occurrenceType/get/${this.id}/${this.companyId}`;
      }
      return `/v1/occurrenceType/get/${this.id}`;
    },
     
  },
 
  methods: {
    async loadData()
    {
      // console.log(this.getUrlOccurrenceTypeList)
      this.$api
      .get(this.getUrlOccurrenceTypeList) //getUrlOccurrenceTypeList
      .then((response) => {
        // console.log("entrou")
        // console.log(response.data);
        let model = response.data;
        this.model = model;
        console.log(model)
      })
      .catch((error) => {
          if (error.response.status == 401) {
            console.log(response.data);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                console.log(response.data);
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },

  save() {
    this.submitted = true;

    this.$api
        .post(
          "/v1/occurrenceType/edit/" + this.model.id,
          this.model
        )
        .then((response) => {
          // console.log("response.data");
          // console.log(response.data);
          this.model = response.data;
          this.$forceUpdate();
          this.$refs.alert.show();
          this.modelstate = {};
          this.submitted = false;
        })
      
      .catch((error) => {
          console.log("error");
          console.log(error);
          this.submitted = false;
          this.modelstate = {};

          if (error.response) {
            console.log(error.response);
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
              this.alert.error = error.message;
              this.$refs.danger.show();
            } else if (error.response.status == 500) {
              this.alert.error = error.response.data;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
  },  
  },
  watch: {
    stateId() {
      this.loadData();
    },
  },
};
</script>
